export const intMaxValue = 2147483647
export const decimalMaxChangeItemValue = 100000000000000
export const reportPopOverMaxTextLength = 50



// WEBPACK FOOTER //
// ./src/utils/constants.js